<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="desc,viewName"
      :show-export="false"
      :show-custom-column="false"
      ref="ecoTable"
    >
      <template v-slot:toolbar>
        <el-button size="small" @click="edit()" type="primary">添加</el-button>
        <fe-delete-button :url="deleteUrl" :htTable="$refs.ecoTable" class="marginLeft16">删除</fe-delete-button>
      </template>
      <eco-table-column type="index" width="50" align="center" label="序号" />
      <eco-table-column prop="desc" label="描述">
        <template slot-scope="scope">
          <el-link type="primary" @click="edit(scope.row.id)" title="查看详情">{{ scope.row.desc }}</el-link>
        </template>
      </eco-table-column>
      <eco-table-column prop="viewName" label="视图名称" :sortable="true" />
      <eco-table-column prop="dsAlias" label="数据源别名" :sortable="true" />
      <eco-table-column prop="sql" label="SQL语句" />
      <eco-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.status === 0">未生成视图</el-tag>
          <el-tag type="priamry" v-if="scope.row.status === 1">已生成视图</el-tag>
        </template>
      </eco-table-column>
      <eco-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link @click="createPhysicalView(scope.row.id)" type="primary" :underline="false">生成视图</el-link>
        </template>
      </eco-table-column>
    </eco-table>

    <eco-sidebar-dialog
      destroy-on-close
      width="28%"
      :title="(model.id ? '编辑' : '添加') + '视图'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      append-to-body
    >
      <el-form v-model="model" data-vv-scope="editModelForm" style="padding: 20px">
        <eco-form-item label="描述" label-width="120px">
          <eco-input v-model="model.desc" autocomplete="off" :validate="{ required: true }" placeholder="请输入描述"></eco-input>
        </eco-form-item>
        <eco-form-item label="视图名称" label-width="120px">
          <eco-input
            v-model="model.viewName"
            autocomplete="off"
            :disabled="model.id ? true : false"
            :validate="{ required: true, alpha_dash: true }"
            placeholder="请输入视图名称"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="数据源" label-width="120px">
          <eco-select
            v-model="model.dsAlias"
            :options="dataSources"
            :disabled="model.id ? true : false"
            :props="{ key: 'alias', value: 'name' }"
            :validate="{ required: true }"
          />
        </eco-form-item>
        <eco-form-item label="sql语句">
          <el-tooltip class="item" effect="dark" :content="content" placement="top-start">
            <i class="el-icon-question" />
          </el-tooltip>
          <eco-input type="textarea" v-model="model.sql" :autosize="{ minRows: 10, maxRows: 10 }" :validate="{ required: true }" />
          &nbsp;&nbsp;<el-button type="primary" @click="checkSql">验证SQL</el-button>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose()">{{ $t('eip.common.cancel') }}</el-button
        ><fe-submit-button
          url="/form/viewManage/v1/save/0"
          context="form"
          :model="model"
          scope-name="editModelForm"
          :is-submit="checkState"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
        <fe-submit-button
          url="/form/viewManage/v1/save/1"
          context="form"
          :model="model"
          scope-name="editModelForm"
          :is-submit="checkState"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveData"
          >保存并生成视图</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <fe-load-data :url="loadDataUrl" context="form" @after-load-data="afterLoadData"></fe-load-data>
  </div>
</template>

<script>
import form from '@/api/form.js'
export default {
  data() {
    return {
      data: [],
      pageResult: {
        page: 0,
        pageSize: 50,
        total: 0
      },
      selectedId: '',
      deleteUrl: window.context.form + '/form/viewManage/v1/remove',
      dialogVisible: false,
      loadDataUrl: '',
      model: {},
      dataSources: [],
      isChecked: false,
      content: '请输入符合生成视图的SQL，如联表查询时存在重复字段将会导致验证通过但最后保存并生成视图时出错！',
      checkState: false
    }
  },
  mounted() {
    form.getDataSource().then((resp) => {
      this.dataSources = resp.data
    })
  },
  methods: {
    checkSql() {
      if (!this.model.sql) {
        this.$message({ type: 'warning', message: '请输入sql语句' })
        return
      }
      if (!this.model.dsAlias) {
        this.$message({ type: 'warning', message: '请选择数据源' })
        return
      }
      let param = { sql: this.model.sql, dsName: this.model.dsAlias }
      form.checkSql(param).then((response) => {
        if (response.state) {
          this.$message({ type: 'success', message: response.message })
          this.checkState = response.state
        }
      })
    },
    loadData(param, cb) {
      form
        .getViewManageList(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => {
          cb()
        })
    },
    edit(id) {
      this.dialogVisible = true
      if (id) {
        this.loadDataUrl = `/form/viewManage/v1/getJson?id=${id}`
      } else {
        this.model = {}
        this.loadDataUrl = ''
      }
    },
    afterLoadData(data) {
      this.model = data
    },
    beforeSaveData() {
      if (!this.checkState) {
        this.$message({ type: 'warning', message: '请先验证SQL！' })
      }
    },
    afterSaveData() {
      this.dialogVisible = false
      this.checkState = false
      this.$refs.ecoTable.load()
    },
    handleClose() {
      this.dialogVisible = false
    },
    createPhysicalView(id) {
      form.createPhysicalViewByViewMngId(id).then((response) => {
        if (response.state) {
          this.$message({ type: 'success', message: response.message })
          this.$refs.ecoTable.load()
        }
      })
    }
  }
}
</script>

<style scoped></style>
